export default function escapeAgainstXss(string="") {
  return string.replace(/&/g, '＆')
    .replace(/</g, '＜')
    .replace(/>/g, '＞')
}